
export default {
  namespaced: true,
  state: {
    sidebarForm: {},
  },
  getters: {
  },
  setters: {
  },
  mutations: {
    setmodal(state, payload) {
      setTimeout(() => {
        // console.log('commit' , payload);
        state.sidebarForm = payload;
      }, 100);
    }
  },
  actions: {  
    setmodal({ commit }, form) {
      // console.log("setmodal" , form);
      commit("setmodal", form);
    }
  }
};
